module.exports = __webpack_public_path__ + "static/img/gaozhongdili3.1a77bc54.jpg";